module.exports = __webpack_public_path__ + "static/media/medicare-logo-green.d32c2185.svg";